import MidiEffect from './MidiEffect.js';
import {getTrackName} from 'utils/getTrackName.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';

class MidiOutputter extends MidiEffect {
    constructor(track) {
        super('Midi Outputter', track);

        // parameters for the arpeggiator
        this.trackOutputParameter = new AbstractParameter(
            'trackOutput', this, (o, x) => x,
            {
                min: 0,
                max: 16,
                unit: '',
                defaultValue: undefined,
            });
        this.registerParameter(this.trackOutputParameter);

        // parameters for the arpeggiator
        this.probabilityParameter = new AbstractParameter(
            'probability', this, (o, x) => x,
            {
                min: 0,
                max: 100,
                unit: '',
                defaultValue: 100
            });
        this.registerParameter(this.probabilityParameter);
    }

    get documentation() {
        return "Routes triggers from this track to another track.";
    }

    getCopy(track, ignoreId=true) {
        let fx = new MidiOutputter(track);
        fx.fromJson(this.getJson(), ignoreId);
        return fx;
    }

    getAvailableParameters() {
        return [
            this.track.trackData.durationParameter,
            this.track.trackData.chopParameter,
            this.track.trackData.velocityParameter,
            this.track.trackData.transposeParameter,
            this.track.trackData.attackParameter,
            this.track.trackData.releaseParameter,
            this.track.trackData.pitchAttackParameter,
            this.track.trackData.pitchDecayParameter,
            this.track.trackData.pitchSustainParameter,
            this.track.trackData.pitchReleaseParameter,
        ];
    }

    set trackOutput(x) {
        this.trackOutputParameter.set(x);
    }

    get trackOutput() {
        return this.trackOutputParameter.get();
    }

    set probability(x) {
        this.probabilityParameter.set(x);
    }

    get probability() {
        return this.probabilityParameter.get();
    }

    getTrack() {
        return this.track.subSequence.tracks[Math.round(this.trackOutput)];
    }

    getVisualizedParameters() {
        return [this.trackOutputParameter];
    }

    getText() {
        let track = this.getTrack();
        if (track) {
            return (track.trackNumber + 1) + ". " + getTrackName(track);
        }
        return undefined;
    }

    output(time, stepNumber, actualStepNumber) {
        let random = Math.random();
        if (random < this.probability / 100.0) {
            if (this.trackOutput) {
                let track = this.track.subSequence.tracks[Math.round(this.trackOutput)];
                if (track === undefined || track === this.track) {
                    return this.triggers;
                }
                // send the triggers to the track
                track.onNewStep();
                for (let i in this.triggers) {
                    track.midiEffects.input(
                        // this.triggers[i].stepData.getCopy(true, false),
                        this.getStep(this.triggers[i].stepData, undefined, undefined, true),
                        this.triggers[i].time,
                        actualStepNumber);
                }
                let triggers = track.midiEffects
                    .output(time, stepNumber, actualStepNumber);
                track.otherTriggerCount = triggers.length;
                triggers.forEach(
                    trigger =>
                        track.trigger(trigger.stepData, trigger.time));

                track.onStepEnded(time, stepNumber);
            }

        }

        return this.triggers;
    }
}

export default MidiOutputter;
